import Modal from 'bootstrap/js/dist/modal';

const VIDEO_MODAL_SELECTOR = '.js-video-modal';

const getEmbedUrl = (rawUrl) => {
    if (!rawUrl) {
        return '';
    }

    try {
        const url = new URL(rawUrl, window.location.href);
        const host = url.hostname.replace('www.', '');

        if (host === 'youtu.be') {
            const videoId = url.pathname.split('/').filter(Boolean)[0];
            return videoId ? `https://www.youtube.com/embed/${videoId}` : rawUrl;
        }

        if (host === 'youtube.com' || host === 'm.youtube.com') {
            const videoId = url.searchParams.get('v');
            if (videoId) {
                return `https://www.youtube.com/embed/${videoId}`;
            }

            const pathParts = url.pathname.split('/').filter(Boolean);
            if (pathParts[0] === 'embed' || pathParts[0] === 'shorts') {
                return pathParts[1] ? `https://www.youtube.com/embed/${pathParts[1]}` : rawUrl;
            }
        }

        if (host === 'vimeo.com' || host === 'player.vimeo.com') {
            const videoId = url.pathname.split('/').filter(Boolean).pop();
            return videoId ? `https://player.vimeo.com/video/${videoId}` : rawUrl;
        }
    } catch (error) {
        return rawUrl;
    }

    return rawUrl;
};

const withAutoplay = (url) => {
    if (!url) {
        return '';
    }

    if (url.includes('autoplay=1')) {
        return url;
    }

    return url.includes('?') ? `${url}&autoplay=1` : `${url}?autoplay=1`;
};

document.querySelectorAll(VIDEO_MODAL_SELECTOR).forEach((modalEl) => {
    Modal.getOrCreateInstance(modalEl);

    modalEl.addEventListener('show.bs.modal', (event) => {
        const trigger = event.relatedTarget;
        if (!trigger) {
            return;
        }

        const rawUrl =
            trigger.getAttribute('data-video-src') ||
            trigger.getAttribute('data-mfp-src') ||
            trigger.getAttribute('href');
        if (!rawUrl) {
            return;
        }

        const iframe = modalEl.querySelector('.video-modal-iframe');
        if (!iframe) {
            return;
        }

        const embedUrl = getEmbedUrl(rawUrl);
        iframe.setAttribute('src', withAutoplay(embedUrl));
    });

    modalEl.addEventListener('hidden.bs.modal', () => {
        const iframe = modalEl.querySelector('.video-modal-iframe');
        if (iframe) {
            iframe.setAttribute('src', '');
        }
    });
});
